@if (src.startsWith('https://img.youtube')) {
  <div>
    <img [defaultImage]="defaultImage" [lazyLoad]="src" (onStateChange)="handler($event)" [offset]="500" [alt]="alt" id="image_variant">
    <div class="yt"></div>
  </div>
}

@if (!src.startsWith('https://img.youtube')) {
  <div>
    <img [defaultImage]="defaultImage" [lazyLoad]="src" (onStateChange)="handler($event)" [offset]="500" [alt]="alt" id="image_variant">
  </div>
}